module.exports = __webpack_public_path__ + "static/media/load.2ae225e9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/black/load.svg
// module id = 1338
// module chunks = 0